import { DatePicker } from '@didi-pebble/pebble-design-react';
import dayjs from 'dayjs';

import { useNotPC } from '@/utils';

import MobileRangePicker from '../mobileRangePicker';

import type { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

const ResponsiveRangePicker = ({ ...props }: any) => {
  const isNotPC = useNotPC();
  const {
    style,
    presets,
    showTime,
    format,
    allowClear,
    value = [],
    onChange,
    maxRange = 180
  } = props;

  const disabledDate: any = (current: Dayjs, info?: { from: Dayjs }) => {
    const { from } = info || {};
    const isNextDay = current && current > dayjs().endOf('day'); // 是否大于当前日期
    const outDays =
      from && (current > from.add(maxRange, 'day') || current < from.subtract(maxRange, 'day')); // 是否大于开始日期后10天

    return isNextDay || outDays;
  };

  return (
    <div>
      {isNotPC ? (
        <MobileRangePicker
          value={value}
          onChange={onChange}
          style={style}
          showTime={showTime}
          maxRange={maxRange}
          presets={presets}
          format={format}
          allowClear={allowClear}
        />
      ) : (
        <RangePicker
          value={value}
          style={style}
          showTime={showTime}
          disabledDate={disabledDate}
          onChange={val => {
            onChange?.(val);
          }}
          presets={presets}
          getPopupContainer={(triggerNode: any) => triggerNode.parentElement}
          format={format}
          allowClear={allowClear}
        />
      )}
    </div>
  );
};

export default ResponsiveRangePicker;
